theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");
    const mainEl = document.querySelector("main");
    const announcementBar = document.querySelector('.announcement__area');
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

    if (headerStickyTargetList.length > 0) {
      headerStickyTargetList.forEach((headerStickyTarget) => {
        const headerHeight = headerStickyTarget.offsetHeight;

        const placeholder = document.createElement("div");
        placeholder.style.height = (headerHeight - announcementHeight) + "px";
        mainEl.parentNode.insertBefore(placeholder, mainEl);

        headerStickyTarget.classList.add("sticky");
        headerStickyTarget.style.top = announcementHeight + "px";

        // Actualizează top la scroll
        window.addEventListener('scroll', function() {
          const scrollY = window.scrollY;
          if (scrollY > announcementHeight) {
            headerStickyTarget.style.top = "0px";
          } else {
            headerStickyTarget.style.top = (announcementHeight - scrollY) + "px";
          }
        });
      });
    }
  }
  return ScrollSticky;
})();

document.addEventListener('DOMContentLoaded', function() {
  theme.headerSticky();
});